import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import TextFieldComponent from "../CustomUIComponents/TextFieldComponent/TextFieldComponent";
import { Strings } from "../../resources/i18n/i18n";
import { loanApplicationFormInputs } from "../CreateLoan/CreateLoanConstants";
import CheckboxComponent from "../CustomUIComponents/CheckboxComponent/CheckboxComponent";

class SiteVisit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            siteVisit: {
                numberOfMotors: this.props.siteVisit?.numberOfMotors,
                numberOfExhibitors: this.props.siteVisit?.numberOfExhibitors,
                numberOfBotellero: this.props.siteVisit?.numberOfBotellero,
                numberOfCars: this.props.siteVisit?.numberOfCars,
                numberOfTVs: this.props.siteVisit?.numberOfTVs,
                numberOfTelephones: this.props.siteVisit?.numberOfTelephones,
                numberOfFreezers: this.props.siteVisit?.numberOfFreezers,
                numberOfFridges: this.props.siteVisit?.numberOfFridges,
                localType: this.props.siteVisit?.localType,
                investor: this.props.siteVisit?.investor,
                roofType: this.props.siteVisit?.roofType,
            },
            errorFieldArray: [],
            errorMessage: "",
            invalidFormField: []
        };
    }

    componentDidMount() {
        const { invalidFormField } = this.props;
        const { siteVisit } = this.state;

        if (Array.isArray(invalidFormField) && invalidFormField.length > 0) {
            const siteVisitFields = invalidFormField.find(field => field.ft === "SITE_VISIT")?.ff || [];

            if (siteVisitFields.length > 0) {
                const updatedSiteVisit = { ...siteVisit };

                siteVisitFields.forEach(field => {
                    if (field in updatedSiteVisit) {
                        updatedSiteVisit[field] = null;
                    }
                });
                this.setState({
                    siteVisit: updatedSiteVisit,
                    invalidFormField: siteVisitFields,
                    errorFieldArray: siteVisitFields,
                    errorMessage: Strings("pleaseSelectRequiredFields")
                });
            }
        }
        this.props.scrollToTop();
    }

    handleCheckBoxChange = () => {
        this.setState(prevState => {
            const errorFieldArray = prevState.errorFieldArray?.filter(key => key !== "investor") || [];
            const errorMessage = errorFieldArray.length === 0 ? "" : prevState.errorMessage;
            return {
                errorFieldArray,
                errorMessage,
                siteVisit: {
                    ...prevState.siteVisit,
                    investor: !prevState.siteVisit.investor
                }
            };
        });
    };
    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => {
            const errorFieldArray = prevState.errorFieldArray?.filter(key => key !== name) || [];
            let invalidFormField = prevState.invalidFormField?.filter(key => key !== name) || [];
            const errorMessage = errorFieldArray.length === 0 ? "" : prevState.errorMessage;

            return {
                errorFieldArray,
                invalidFormField,
                errorMessage,
                siteVisit: {
                    ...prevState.siteVisit,
                    [name]: value
                }
            };
        });
    };


    renderSelectionDropDown = (prop) => {
        const errorClass = this.state.errorFieldArray.includes(prop.key)
            ? " error-data"
            : "";

        const matchedDropdown = this.props.siteVisitList?.find(item => item.nm === prop.key);
        let dropDownList = matchedDropdown?.opt || [];
        if (prop.key === "localType") {
            const localTypeItem = this.props.siteVisitList?.find(item => item.nm === "premises");
            dropDownList = localTypeItem?.opt?.map(opt => opt.toUpperCase()) || [];
        }
        return (
            <div className={`textFieldComponent ${errorClass}`}>
                <TextFieldComponent
                    title=""
                    id={prop.name}
                    type={prop.type}
                    className="noMargin"
                    placeholder={prop.title}
                    handleChange={this.handleChange}
                    value={this.state.siteVisit[prop.key] || ""}
                    multiple={false}
                    halfWidth={false}
                    disabled={prop.disabled || this.props.disableTextField}
                    name={prop.key}

                >
                    {prop.isSelection && (
                        <>
                            <option value="">{Strings("select")}</option>
                            {dropDownList.map((version) => (
                                <option
                                    key={
                                        version.value ||
                                        version.label ||
                                        version.name ||
                                        version.key ||
                                        version.pstid ||
                                        version
                                    }
                                    value={
                                        version.value ||
                                        version.label ||
                                        version.id ||
                                        version.pstid ||
                                        version.name ||
                                        version
                                    }
                                    disabled={
                                        this.props.ZONE_POSITION && version.pstid === prop.value
                                    }
                                >
                                    {version.label ||
                                        version.name ||
                                        version.pstn ||
                                        Strings(version)}
                                </option>
                            ))}
                        </>
                    )}
                </TextFieldComponent>
            </div>
        );
    };
    renderCheckBox = (prop) => {
        return (
            <CheckboxComponent
                name={prop.key}
                onChange={() => {
                    this.handleCheckBoxChange("investor")
                }}
                checked={this.state.siteVisit[prop.key]}
                disabled={this.props.disableTextField}
                label={Strings(prop.key)}
                key={prop.key}
            />
        )
    }
    renderSiteVisit = (editableData) => {
        return (
            <Row className='subHeaderApplication addOrUpdateUserFontSize ps-3'>
                {editableData.map((prop) => {
                    let inputField = prop.isSelection
                        ? this.renderSelectionDropDown(prop)
                        : this.renderCheckBox(prop)
                    return (
                        <Col
                            key={prop.name}
                            md={{ span: prop.md || 4 }}
                            className='ps-0 pe-3'
                        >
                            <Row>
                                <Col md={11}>
                                    <Row>
                                        <Col md={12} className='px-0 pt-3'>
                                            <span className={prop.className || ""}>
                                                {Strings(prop.name)}
                                            </span>
                                            {prop.isMandatory && (
                                                <span className='mandatoryFields'>*</span>
                                            )}
                                        </Col>
                                        <Col
                                            md={12}
                                            className={
                                                prop.key === "investor"
                                                    ? "px-0 pt-4 textFieldComponent fullWidth"
                                                    : "px-0 pt-2 textFieldComponent fullWidth"
                                            }
                                        >
                                            {inputField}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    );
                })}
            </Row>
        );
    };

    validateData = () => {
        if (this.props.disableTextField) {
            this.props.goNext();
            return;
        }
        const errorFieldArray = [];
        const { siteVisit } = this.state;
        const mandatoryFields = loanApplicationFormInputs.siteVisit
            .filter(field => field.isMandatory)
            .map(field => field.key);
        mandatoryFields.forEach((key) => {
            if (!siteVisit[key]) {
                errorFieldArray.push(key);
            }
        });
        let finalErrorFieldArray = [...errorFieldArray, ...this.state.invalidFormField];
        this.setState({ errorFieldArray: finalErrorFieldArray });

        if (finalErrorFieldArray.length === 0) {
            this.setState({ errorMessage: "" });
            this.props.callAPI(siteVisit, (errorMessage) => {
                this.setState({ errorMessage: errorMessage });
            });
        } else {
            this.setState({ errorMessage: Strings("pleaseSelectRequiredFields") });
        }
    };

    renderButtons = () => {
        return (
            <Row className='modalButton justify-content-between ps-3'>
                <Col md={2} className='text-start'>
                    <Button
                        className='buttonBorder'
                        onClick={this.props.goBack}
                        disabled={this.props.showLoadingModalState}
                    >
                        {Strings("Back").toUpperCase()}
                    </Button>

                </Col>
                <Col md={4} className='d-flex justify-content-end pe-4'>
                    <Button
                        className='buttonBorder me-4'
                        onClick={this.props.goNext}
                        disabled={(!this.props.siteVisit?.prefillData) || this.props.showLoadingModalState}
                    >
                        {Strings("Next").toUpperCase()}
                    </Button>
                    {!this.props.disableTextField && <Button
                        className='buttonBackground'
                        onClick={this.validateData}
                        disabled={this.props.showLoadingModalState}
                    >
                        {Strings("saveAndProceed")}
                    </Button>}
                </Col>
            </Row>
        )
    }
    renderErrors = () => {
        return (
            <Col md={12} className='errors ps-4 mb-0 ms-1'>
                {this.state.errorMessage}
            </Col>
        )
    }
    render() {

        return (
            <Col md={12}>
                {this.renderErrors()}
                {this.renderSiteVisit(loanApplicationFormInputs.siteVisit)}
                <hr className="opacity-100 mb-2 mt-4 ms-2 me-2" />
                {this.renderButtons()}
            </Col>
        );
    }
}

export default SiteVisit;
